import { JobStatuses } from '../../../../../../types/api/print-job'
import { DocumentId, EndpointQueryParameters } from '../../../../../../types/strapi/strapi'

export default function getCreatedPrintJobsFilters(
    machineDocIds: DocumentId[]
): EndpointQueryParameters['filters'] {
    return {
        jobStatus: { $eq: JobStatuses.Created },
        shipment: {
            machine: {
                documentId: { $in: machineDocIds },
            },
        },
    }
}
